import { ThemeContext } from "@/context/ThemeContext";
import { Editor } from "@monaco-editor/react";
import { useContext } from "react";

type CodeEditorProps = {
  value: string;
  handleChange: (value: string) => void;
  language: string;
};

const CodeEditor = ({ value, handleChange, language }: CodeEditorProps) => {
  const currentTheme = useContext(ThemeContext);
  return (
    <Editor
      theme={currentTheme.current === "light" ? "light" : "vs-dark"}
      className="h-[300px] w-full rounded-xl"
      language={language}
      value={value}
      onChange={value => handleChange(value ?? "")}
      options={{
        readOnly: false,
        fontSize: 14,
        fontFamily: "Consolas, 'Courier New', monospace",
        lineNumbers: "on",
        wordWrap: "on",
        minimap: {
          enabled: true,
        },
        tabSize: 4,
        scrollBeyondLastLine: false,
        automaticLayout: true,
        formatOnType: true,
        formatOnPaste: true,
        autoClosingBrackets: "always",
        autoClosingQuotes: "always",
        matchBrackets: "always",
        cursorBlinking: "blink",
        quickSuggestions: {
          other: true,
          comments: false,
          strings: true,
        },
        suggestOnTriggerCharacters: true,
        acceptSuggestionOnEnter: "on",
        folding: true,
        renderWhitespace: "boundary",
        scrollbar: {
          vertical: "auto",
          horizontal: "auto",
        },
        bracketPairColorization: {
          enabled: true,
        },
        guides: {
          bracketPairs: true,
        },
      }}
    />
  );
};

export default CodeEditor;
